import React from 'react';

export function List({ list = null, isCol = false }) {
  const classNames = `nf-list fc fc-a-c ${isCol ? 'fc-dc' : ''}`; 
  return (
    <div className={ classNames }>
     { list }
    </div>
  )
}